import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import GreenSparks from './GreenSparks';

const mainLayoutRootStyle = {
  minHeight: '100vh',
  width: '100%',
  position: 'relative',
  zIndex: 1,
};

const MainLayout = () => {
  return (
    <div style={mainLayoutRootStyle} className="app-container main-layout-root">
      <GreenSparks />
      <Header />
      <main className="pageContent">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
